
import React from 'react';

function LessCardsFPS({ data, monthName, year, check }) {
  if (!data || data.length === 0) {
    return <div className="mainhead">No Data Found</div>;
  }
  return (
    <div align="center">
      <table align="center" width="70%">
        <thead>
          <tr className="tableheader">
            <td colSpan="6">Less than <font style={{ color: "orange" }}>{check}</font> Cards FPS in <font style={{ color: "orange" }}>{monthName} '{year}</font></td>
          </tr>
          <tr className="tableheader">
            <td>Sl No</td>
            <td>District</td>
            <td>office</td>
            <td>FPS</td>
            <td>Total<br/>Cards</td>
            <td>No Of<br/>Members</td>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{item.distName}</td>
              <td>{item.officeName}</td>
              <td>{item.fpsId}</td>
              <td align="right">{item.totalCards}</td>
              <td align="right">{item.totalUnits}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default LessCardsFPS;